/** Row shape passed by MRT filterFn: row.original is FleetEventRow. */
type RowWithUser = { original: { user?: { firstName?: string; surname?: string } | null } };

/**
 * MRT filterFn for the "Booking User" column: matches when filter text is contained
 * in the user's first name or surname (case-insensitive).
 */
export function filterFleetEventByUser(
  row: RowWithUser,
  _columnId: unknown,
  filterValue: string | number
): boolean {
  const user = row.original.user;

  if (!user) return false;
  if (typeof filterValue !== "string" && typeof filterValue !== "number") return false;

  const filterStr = typeof filterValue === "string" ? filterValue : String(filterValue);
  const lower = filterStr.toLowerCase();
  const first = (user.firstName ?? "").toLowerCase();
  const last = (user.surname ?? "").toLowerCase();

  return first.includes(lower) || last.includes(lower);
}
